import { isEmpty } from 'remeda';

import { api } from './base';

import { rewardsService } from 'v2/api/rewardsService';
import { MutationArg } from 'v2/types';
import { LevelForm, LevelModel } from 'v2/types/LevelModel';
import { VipLevelModel } from 'v2/types/VipLevelModel';

export const levelsService = {
  getLevels(): Promise<LevelModel[]> {
    return api.get('admin/user-level', { searchParams: { isVip: false } }).json();
  },

  getVipLevels(): Promise<VipLevelModel[]> {
    return api.get('v1/admin/vip/level').json();
  },

  createLevel(_key: string, { arg: levelForm }: MutationArg<LevelForm & { level: number }>): Promise<LevelModel> {
    if (isEmpty(levelForm.rewards)) {
      return api.post('admin/user-level', { json: levelForm }).json();
    } else
      return rewardsService
        .createRewards('createRewards', { arg: levelForm.rewards })
        .then((levelRewards) => api.post('admin/user-level', { json: { ...levelForm, levelRewards } }).json());
  },

  updateLevel([_key, level]: [string, LevelModel], { arg: levelForm }: MutationArg<LevelForm>): Promise<LevelModel> {
    return rewardsService
      .deleteRewards(['deleteRewards', level.levelRewards])
      .then(() => rewardsService.createRewards('createRewards', { arg: levelForm.rewards }))
      .then((levelRewards) =>
        api.put(`admin/user-level/${level.id}`, { json: { level: level.level, ...levelForm, levelRewards } }).json()
      );
  },

  deleteLevel([_key, level]: [string, LevelModel]): Promise<LevelModel> {
    if (isEmpty(level.levelRewards)) {
      return api.delete(`admin/user-level/${level.id}`).json();
    } else {
      return rewardsService
        .deleteRewards(['deleteRewards', level.levelRewards])
        .then(() => api.delete(`admin/user-level/${level.id}`).json());
    }
  },
};
